// ==========================================
// ACCESSIBILITY FIXES PARA HOLLISTON
// ==========================================

function fixHollistonIssues() {

    // 1. Arreglar el falso positivo de Breadcrumbs en las variantes de producto
    const fixProductVariants = () => {
        // Seleccionamos los fieldsets de opciones de producto (como Color, Talla, etc.)
        const variantFieldsets = document.querySelectorAll('fieldset.product-form__input');

        variantFieldsets.forEach(fieldset => {
            if (fieldset.dataset.a11yFixed === "true") return;
            fieldset.dataset.a11yFixed = "true";

            // Si por algún error del tema de Shopify esto tenía role="navigation", lo quitamos
            if (fieldset.getAttribute('role') === 'navigation') {
                fieldset.removeAttribute('role');
            }

            // Le damos el rol correcto: un grupo de opciones seleccionables
            fieldset.setAttribute('role', 'radiogroup');

            // Le ponemos un aria-label basado en su título (Ej: "Color: Black")
            const legend = fieldset.querySelector('legend');
            if (legend && !fieldset.hasAttribute('aria-label')) {
                fieldset.setAttribute('aria-label', legend.textContent.trim());
            }
        });
    };

    // 2. Arreglar elementos interactivos y botones mal etiquetados
    const fixHollistonButtons = () => {
        // --- CASO A: Botones nativos que confunden al escáner ---
        const nativeButtons = document.querySelectorAll('button.search__button, button.search-modal__close-button');
        nativeButtons.forEach(btn => {
            if (btn.dataset.nativeBtnFixed === "true") return;
            btn.dataset.nativeBtnFixed = "true";

            // Si le falta el 'type', se lo asignamos según su función
            if (!btn.hasAttribute('type')) {
                if (btn.classList.contains('search__button')) {
                    btn.setAttribute('type', 'submit');
                } else {
                    btn.setAttribute('type', 'button');
                }
            }
            
            // Reforzamos la semántica para aplacar al escáner
            if (!btn.hasAttribute('role')) {
                btn.setAttribute('role', 'button');
            }
        });

        // --- CASO B: Enlaces que actúan como botones (Ej: More payment options) ---
        const fakeButtons = document.querySelectorAll('a.shopify-payment-button__more-options, a[href="#"]');
        fakeButtons.forEach(btn => {
            if (btn.dataset.fakeBtnFixed === "true") return;
            btn.dataset.fakeBtnFixed = "true";

            // Los convertimos en botones para el lector de pantalla
            btn.setAttribute('role', 'button');
            if (!btn.hasAttribute('tabindex')) {
                btn.setAttribute('tabindex', '0');
            }

            // Agregamos soporte para activarlos con Enter o Espacio
            btn.addEventListener('keydown', (e) => {
                if (e.key === ' ' || e.key === 'Enter') {
                    e.preventDefault();
                    btn.click();
                }
            });

            // Si es un enlace con solo "#", prevenimos que la página salte hacia arriba
            if (btn.getAttribute('href') === '#') {
                btn.addEventListener('click', (e) => {
                    // Solo prevenimos el default si no es el botón de pagos de Shopify, 
                    // ya que Shopify maneja su propio evento de clic ahí.
                    if (!btn.classList.contains('shopify-payment-button__more-options')) {
                        e.preventDefault();
                    }
                });
            }
        });
    };

    // 3. Arreglar aria-controls rotos (Buscador y Filtros de País)
    const fixInvalidAriaControls = () => {
        const elementsWithAriaControls = document.querySelectorAll('[aria-controls]');

        elementsWithAriaControls.forEach(el => {
            // Evitamos procesar elementos que ya arreglamos
            if (el.dataset.ariaControlsFixed === "true") return;

            const targetId = el.getAttribute('aria-controls');
            
            // Verificamos si el ID al que apunta realmente existe en la página
            if (!document.getElementById(targetId)) {
                
                // Si son nuestros IDs problemáticos, les creamos su contenedor
                if (targetId === 'predictive-search-results' || targetId === 'country-results') {
                    const resultsContainer = document.createElement('div');
                    resultsContainer.id = targetId;
                    resultsContainer.setAttribute('role', 'listbox');
                    // Lo mantenemos oculto para que no afecte el diseño
                    resultsContainer.style.display = 'none'; 

                    // Lo insertamos justo después del input
                    el.parentNode.insertBefore(resultsContainer, el.nextSibling);
                    
                } else {
                    // Si es cualquier otro ID perdido, la regla dicta borrar el atributo para evitar errores
                    el.removeAttribute('aria-controls');
                    if (el.getAttribute('aria-owns') === targetId) {
                        el.removeAttribute('aria-owns');
                    }
                }
            }
            
            // Lo marcamos como arreglado
            el.dataset.ariaControlsFixed = "true";
        });
    };

    // 4. Advertir a los usuarios sobre los enlaces de correo (mailto:)
    const fixMailtoLinks = () => {
        // Buscamos todos los enlaces que su href empiece con "mailto:"
        const mailLinks = document.querySelectorAll('a[href^="mailto:"]');

        mailLinks.forEach(link => {
            // Evitamos procesar el mismo enlace dos veces
            if (link.dataset.mailtoFixed === "true") return;

            // Si tiene un title redundante (ej. title="mailto:..."), lo eliminamos
            if (link.hasAttribute('title')) {
                link.removeAttribute('title');
            }

            // Obtenemos el texto visible del enlace
            const linkText = link.textContent.trim() || 'Email support';

            // Le inyectamos la advertencia en el aria-label
            if (!link.hasAttribute('aria-label')) {
                link.setAttribute('aria-label', `${linkText} (opens email application)`);
            } else {
                // Si ya tenía un aria-label, se lo concatenamos (si no lo tiene ya)
                const currentLabel = link.getAttribute('aria-label');
                if (!currentLabel.includes('email application')) {
                    link.setAttribute('aria-label', `${currentLabel} (opens email application)`);
                }
            }

            // Lo marcamos como arreglado
            link.dataset.mailtoFixed = "true";
        });
    };
    // 5. Arreglar auto-submit engañoso en formularios de Localización (Footer)
    const fixLocalizationAutoSubmit = () => {
        // Buscamos los formularios de país e idioma de Holliston
        const localizationForms = document.querySelectorAll('form.localization-form');

        localizationForms.forEach(form => {
            // Protección para no duplicar el botón si el observer corre varias veces
            if (form.dataset.a11yFixedSubmit === "true") return;

            // 1. Removemos cualquier 'onchange' nativo si existiera en un select
            const selects = form.querySelectorAll('select');
            selects.forEach(select => {
                if (select.hasAttribute('onchange')) {
                    select.removeAttribute('onchange');
                }
            });

            // 2. Verificamos si ya existe un botón submit, y si no, lo inyectamos
            let submitBtn = form.querySelector('button[type="submit"]');
            if (!submitBtn) {
                submitBtn = document.createElement('button');
                submitBtn.type = 'submit';
                submitBtn.textContent = 'Apply';
                
                // Lo ocultamos visualmente usando CSS inline para no depender de hojas de estilo externas
                submitBtn.style.cssText = 'position: absolute; width: 1px; height: 1px; padding: 0; margin: -1px; overflow: hidden; clip: rect(0, 0, 0, 0); white-space: nowrap; border-width: 0;';
                submitBtn.setAttribute('aria-label', 'Apply localization changes');
                
                // Lo agregamos al final del formulario
                form.appendChild(submitBtn);
            }

            // Lo marcamos como arreglado
            form.dataset.a11yFixedSubmit = "true";
        });
    };
    // 6. Limpiar íconos de métodos de pago (Reducir ruido del lector de pantalla)
    const fixPaymentIcons = () => {
        // Buscamos específicamente los SVGs de pago de Shopify que tienen el prefijo "pi-"
        const paymentIcons = document.querySelectorAll('svg[class*="icon"][aria-labelledby^="pi-"]');

        paymentIcons.forEach(svg => {
            // Evitamos reprocesar el mismo elemento
            if (svg.dataset.paymentIconFixed === "true") return;

            // Removemos el rol de imagen que causa el error
            svg.removeAttribute('role');
            
            // Convertimos el ícono en un elemento puramente presentacional/decorativo
            svg.setAttribute('role', 'presentation');
            svg.setAttribute('aria-hidden', 'true');
            svg.setAttribute('focusable', 'false'); // Previene problemas de foco en IE/Edge

            // Marcamos como corregido
            svg.dataset.paymentIconFixed = "true";
        });
    };

    // 7. Evitar que el header pegajoso (Sticky Header) oculte elementos enfocados
    const fixStickyHeaderFocus = () => {
        // Buscamos el header de Holliston (en los temas modernos de Shopify suele ser <header> con la clase .header o <sticky-header>)
        const header = document.querySelector('sticky-header') || document.querySelector('header.header');
        
        if (!header) return;

        const updateScrollPadding = () => {
            // Calculamos la altura real del header en píxeles
            const headerHeight = header.getBoundingClientRect().height;
            
            // Le aplicamos un "colchón" invisible a toda la página agregando 10px extra para que respire
            document.documentElement.style.scrollPaddingTop = `${headerHeight + 10}px`;
        };

        // Lo ejecutamos la primera vez
        updateScrollPadding();

        // Evitamos duplicar el event listener si el observer corre varias veces
        if (header.dataset.stickyFixed === "true") return;
        header.dataset.stickyFixed = "true";

        // Si el usuario cambia el tamaño de la ventana (o gira el celular), recalculamos la altura
        window.addEventListener('resize', updateScrollPadding);
    };

    // 8. Arreglar falsos "Tabs" en la localización del footer (Moneda e Idioma)
    const fixFooterTabsHolliston = () => {
        // 1. Al contenedor principal le damos el rol de 'tablist'
        const tabContainers = document.querySelectorAll('.footer__localization localization-form, .footer__localization');
        
        tabContainers.forEach(container => {
            if (container.dataset.tablistFixed === "true") return;
            
            container.setAttribute('role', 'tablist');
            container.setAttribute('aria-label', 'Localization options');
            
            container.dataset.tablistFixed = "true";
        });

        // 2. A los botones internos (United States, English) les damos el rol de 'tab'
        const tabButtons = document.querySelectorAll('.footer__localization button.localization-form__select');
        
        tabButtons.forEach(btn => {
            if (btn.dataset.tabFixed === "true") return;
            
            btn.setAttribute('role', 'tab');
            
            // Un tab válido necesita declarar si está seleccionado o no
            if (!btn.hasAttribute('aria-selected')) {
                // Por defecto lo ponemos en false para cumplir la regla
                btn.setAttribute('aria-selected', 'false'); 
            }
            
            btn.dataset.tabFixed = "true";
        });
    };

    // --- EJECUCIÓN DE FUNCIONES ---
    fixProductVariants();
    fixHollistonButtons();
    fixInvalidAriaControls();
    fixMailtoLinks();
    fixLocalizationAutoSubmit();
    fixPaymentIcons();
    fixStickyHeaderFocus();
    fixFooterTabsHolliston(); 
}

// ==========================================
// INICIALIZACIÓN Y OBSERVER
// ==========================================
function initHollistonA11y() {
    fixHollistonIssues();

    // Observer ligero para contenido dinámico (Quick views, carritos laterales, etc.)
    let debounceTimer;
    const observer = new MutationObserver((mutations) => {
        let needsUpdate = false;
        for (const mutation of mutations) {
            if (mutation.addedNodes.length > 0) {
                needsUpdate = true;
                break;
            }
        }
        if (needsUpdate) {
            clearTimeout(debounceTimer);
            debounceTimer = setTimeout(() => {
                requestAnimationFrame(() => {
                    fixHollistonIssues();
                });
            }, 300);
        }
    });

    observer.observe(document.body, {
        childList: true,
        subtree: true,
        attributes: false
    });
}

// Arrancar cuando el DOM esté listo
if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initHollistonA11y);
} else {
    initHollistonA11y();
}